import {useLocation} from "react-router-dom";
import React, {useEffect, useMemo, useState} from "react";
import {EditLocalStoragePagesData} from "../../../utils/EditLocalStoragePagesData";
import Box from "@mui/material/Box";
import {
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Input,
    Typography
} from "@mui/material";
import {
    MaterialReactTable,
    MRT_GlobalFilterTextField,
    MRT_ToggleFiltersButton,
    MRT_ToolbarAlertBanner
} from "material-react-table";
import MenuItem from "@mui/material/MenuItem";
import {MRT_Localization_RU} from "material-react-table/locales/ru";
import ButtonExit from "../../../components/UI/button/ButtonExit";
import ButtonAdd from "../../../components/UI/button/ButtonAdd";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import AdminPictureService from "../../../API/admin/AdminPictureService";
import UtilityService from "../../../API/common/UtilityService";

const Folders = ({itemId, handleModalAlert}) => {
    const pathname = useLocation().pathname
    const [data, setData] = useState([]);
    const [currentEditRowData, setCurrentEditRowData] = useState(null);
    const [modal, setModal] = useState(false);
    const [tableOptions, setTableOptions] = useState({
        pageIndex: 0,
        pageSize: 100,
        totalElements: 7,
        searchData: ""
    })

    useEffect(() => {
        getStartPageSize()
        UtilityService.getFolders().then(function (response) {
            setData(response.data);
            setTableOptions((prev) => ({...prev, totalElements: response?.data.length}))
        })
            .catch(function (error) {
                handleModalAlert(error);
            });
    }, []);

    const tableOptionsHandle = (nextState) => {
        setTableOptions(nextState)
        if (nextState.pageSize !== tableOptions.pageSize) {
            EditLocalStoragePagesData(`${pathname}+${itemId}`, "pageSize", nextState.pageSize)
        }
    }

    const getStartPageSize = () => {
        const pagesData = JSON.parse(localStorage.getItem('pagesData')) || {}
        const pageSize = pagesData[`${pathname}+${itemId}`]?.pageSize
        pageSize && setTableOptions((prev) => ({...prev, pageSize: pageSize}))
    }

    const handleAdd = (row) => {
        setModal(true)
        setCurrentEditRowData(row)
    };

    const addFile = (file, handleClose) => {
        AdminPictureService.addFile(currentEditRowData.filePath, file)
            .then(function () {
                handleClose()
                handleModalAlert("Данные добавлены", 'success')
            })
            .catch(function (error) {
                handleModalAlert(error)
            })
    };

    const columns = useMemo(() => {
        const baseColumns = [
            {
                header: 'Наименование', accessorKey: 'fileName', minSize: 300,
            },
            {
                header: 'Путь', accessorKey: 'filePath', minSize: 400,
            },
        ]
        return baseColumns;

    }, [data]);

    const menuItem = [{type: "add", text: "Добавить файл в папку", handler: handleAdd}]

    return (<div>
        <Typography sx={{
            fontSize: "24px",
            fontWeight: 700,
            lineHeight: 1
        }}>Папки</Typography>
        <Box
            sx={{display: 'flex', justifyContent: "space-between", paddingTop: "30px"}}
        />
        <MaterialReactTable
            renderTopToolbar={({table}) => {
                return <Box sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    padding: "7px",
                    backgroundColor: (theme) => table.getSelectedRowModel().rows.length > 0 ? theme.palette.primary.light : "transparent",
                }}>
                    <MRT_ToolbarAlertBanner table={table}/>
                    <Box sx={{display: "flex"}}>
                        <MRT_ToggleFiltersButton table={table}/>
                        <MRT_GlobalFilterTextField table={table}/>
                    </Box>
                </Box>
            }}
            muiTableContainerProps={{
                sx: {
                    width: '800px',
                    maxHeight: `calc(100vh - 420px)`

                }
            }}
            muiTableBodyCellProps={{
                sx: {
                    p: '0px 0px 0px 10px',
                    m: '0px 0px 0px 0px',
                    border: "none",
                    "& td:after": {
                        "&:hover": {
                            backgroundColor: "red"
                        }
                    },
                    "&:not(:last-of-type)": {
                        borderRight: '1px solid #EAEBEA',

                    },
                    "&:first-of-type": {
                        padding: 0,
                        width: "50px",
                        height: "36px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        color: (theme) => theme.palette.text.light,
                        "& .MuiButtonBase-root": {
                            borderRadius: "4px",
                            width: "24px",
                            height: "24px",
                            opacity: 1,
                            margin: 0,
                            padding: 0,
                            "&:hover": {
                                backgroundColor: (theme) => theme.palette.primary.stroke,
                            }
                        }
                    },
                    "& li": {
                        listStyleType: "none",
                        "& a": {
                            color: "#006CCC",
                            textDecoration: "none",
                            "&:hover": {
                                textDecoration: "underline"
                            }
                        }
                    }
                },
            }}
            muiTableHeadCellProps={{
                sx: {
                    border: '1px solid #EAEBEA',
                    backgroundColor: "#F5F6FA",
                    padding: "10px",
                    paddingBottom: " 0.2rem",
                    paddingTop: "0.2rem"
                },
            }}
            muiTableBodyRowProps={({row}) => {
                return ({
                    sx: () => ({
                        height: '36px',
                        backgroundColor: "white",
                        "&:hover& td:after": {
                            display: "none",
                        },
                        "&:hover": {
                            "& td:after": {
                                display: "none",
                            },
                        },
                        '&:nth-of-type(even)': {
                            backgroundColor: (theme) => theme.palette.primary.lightGrey,
                        },
                    })
                })
            }}

            displayColumnDefOptions={{
                'mrt-row-actions': {
                    header: "",
                    size: 3,
                    minSize: 3,
                    grow: false,
                },
            }}
            muiSearchTextFieldProps={{
                placeholder: `Поиск`,
                sx: {
                    paddingTop: "5px",
                    paddingBottom: "0px",
                    "& .MuiCollapse-root": {
                        borderRadius: '12px',
                        height: 40, width: 290,
                        "& .MuiSvgIcon-root": {
                            color: "#737478"
                        },
                        '& .MuiOutlinedInput-input': {
                            padding: 0
                        }
                    }
                },
                variant: 'outlined',
            }}
            columns={columns}
            data={data}
            onGlobalFilterChange={value => tableOptionsHandle({...tableOptions, searchData: value})}
            onPaginationChange={(updater) => {
                tableOptionsHandle(updater(tableOptions));
            }}
            manualPagination={true}
            state={{showGlobalFilter: true, pagination: tableOptions}}
            rowCount={tableOptions.totalElements}
            selectionCss={{
                backgroundColor: 'lightblue',
                borderWidth: '2px',
                borderStyle: 'solid',
                borderColor: 'blue',
                borderRadius: '4px',
            }}
            renderRowActionMenuItems={({closeMenu, row}) => menuItem.map(el => {
                return <MenuItem
                    key={el.type}
                    onClick={() => {
                        el.handler(row.original)
                        closeMenu();
                    }}
                    sx={{
                        margin: "0 8px",
                        borderRadius: "4px",
                        "&:hover": {backgroundColor: (theme) => theme.palette.primary.light}
                    }}
                >
                    {el.text}
                </MenuItem>
            })}
            localization={MRT_Localization_RU}
            enableRowActions={true}
            enableToolbarInternalActions={false}
        />
        <AddFileModal
            open={modal}
            onClose={() => setModal(false)}
            handleSubmit={addFile}

        />
    </div>);
}
const AddFileModal = ({open, onClose, handleSubmit}) => {
    const [file, setFile] = useState(null)
    const handleClose = () => {
        onClose()
        setFile(null)
    }

    const handleFileSelect = (event) => {
        setFile(event.target.files[0]);
    };
    return (
        <Dialog open={open} PaperProps={{
            style: {
                minWidth: "400px",
                borderRadius: 8,
            }
        }}>
            <DialogTitle textAlign="center">Загрузить файл</DialogTitle>
            <DialogContent>
                <Box sx={{display: "flex", justifyContent: "center", alignItems: "center", gap: "16px"}}>
                    <label htmlFor={`input`}
                           style={{
                               cursor: "pointer",
                               display: "flex",
                               alignItems: "center",
                               gap: "8px"
                           }}>
                        <AttachFileIcon
                            fontSize="small"
                            sx={{
                                color: (theme) => theme.palette.primary.dark,
                                transform: 'rotate(45deg)',
                            }}/>
                        <Typography sx={{color: (theme) => theme.palette.primary.dark}}>
                            Выберите файл</Typography>
                    </label>
                    <Input id={`input`} sx={{display: "none"}} type="file"
                           onChange={handleFileSelect}/>
                    <Typography
                        sx={{fontSize: "16px"}}>
                        {file?.name}
                    </Typography>
                </Box>
            </DialogContent>
            <DialogActions sx={{p: '1.25rem'}}>
                <ButtonExit text={"Отменить"} onClick={handleClose}/>
                <ButtonAdd text={"Загрузить"} disabled={!file} onClick={() => handleSubmit(file, handleClose)}/>
            </DialogActions>
        </Dialog>
    );
}
export default Folders;